export const CLIENT_LOAD_REQUEST = 'CLIENT_LOAD_REQUEST';
export const CLIENT_LOAD_SUCCESS = 'CLIENT_LOAD_SUCCESS';
export const CLIENT_LOAD_FAILURE = 'CLIENT_LOAD_FAILURE';
export interface CreateClientRequest {
  name: string;
  organization: string;
  client_type: string;
  timezone: string;
  currency: string;
  plan: string;
}
